import React from 'react';
import { compose, mapProps, withProps } from 'recompose';
import { withLabel } from '@/se/components/Label';
import ObjectInput from '@/se/components/inputs/ObjectInput';
import TextInput from '@/se/components/inputs/TextInput';
import { NotificationNumbersInput } from '../NotificationNumbersInput';
import NumberInput from '@/se/components/inputs/NumberInput';
import CheckboxInput from '../CheckboxInput';
import { formatProviderId } from '@/util/providerId';
import BraceletIdInput from '../BraceletIdInput';
import FormContainer from '@/components/forms/FormContainer';
import { useStaffCostAccess } from '@/hooks/useStaffCostAccess';

export default withProps({
  schema: {
    name: compose(
      withLabel('Name'),
      withProps({
        placeholder: 'e.g., Mark Nordstrom',
        autoComplete: 'off',
        required: true,
      })
    )(TextInput),
    phoneNumber: NotificationNumbersInput,
    email: compose(
      withLabel('Email'),
      withProps({
        placeholder: 'e.g., john@clinic.edu',
        autoComplete: 'off',
        required: false,
      })
    )(TextInput),
    braceletId: withProps({ nonPatient: true })(BraceletIdInput),
    hstId: compose(
      withLabel('Provider Id'),
      withProps({
        placeholder: 'e.g., 192',
        autoComplete: 'off',
        required: false,
      }),
      mapProps(({ value, onChange, ...rest }) => ({
        value: formatProviderId(value),
        onChange: next => onChange('l/' + next),
        ...rest,
      }))
    )(NumberInput),
    shouldSendNotification: compose(withProps({ label: 'Send Notification' }))(CheckboxInput),
    isCrna: compose(withProps({ label: 'CRNA' }))(CheckboxInput),
    hourlyRate: compose(
      withLabel('Hourly Rate'),
      withProps({
        autoComplete: 'off',
        required: false,
      })
    )(NumberInput),
  },
  render: ({ name, phoneNumber, email, braceletId, hstId, shouldSendNotification, isCrna, hourlyRate }) => {
    const hasStaffCostAccess = useStaffCostAccess();

    return (
      <FormContainer>
        {name}
        {phoneNumber}
        {email}
        {braceletId}
        {hstId}
        {shouldSendNotification}
        {isCrna}
        {hasStaffCostAccess && hourlyRate}
      </FormContainer>
    );
  },
})(ObjectInput);
